import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { personalityKeys } from "../model/keys"

registerNotification("personality_ready", {
	handle: ({ notification_id, data }, ctx) => {
		let type:
			| "personality-notification-first"
			| "personality-notification-update" = "personality-notification-update"
		if (data.kind === "first") type = "personality-notification-first"
		showNotification({
			type,
			placement: "home",
			origin: "server",
			notificationId: notification_id,
			name: "personality_ready",
			archetype: data.archetype,
		})
		ctx.queryClient.invalidateQueries({
			queryKey: personalityKeys.byUserId(ctx.userId),
		})
	},
	route: () => ({
		to: "/profile/personality",
		search: { aspect: "archetype" } as const,
	}),
	routePopup: null,
})
